import { OneAccordBidSchema } from "./1AccordBidSchema";
import { AdagioBidSchema } from "./AdagioBidSchema";
import { AdaptMXSchema } from "./AdaptMXSchema";
import { AppnexusBidSchema } from "./AppnexusBidSchema";
import { CriteoBidSchema } from "./CriteoBidSchema";
import { GumgumBidSchema } from "./GumgumBidSchema";
import { IxBidSchema } from "./IxBidSchema";
import { KargoBidSchema } from "./KargoBidSchema";
import { MedianetBidSchema } from "./MedianetBidSchema";
import { PubmaticBidSchema } from "./PubmaticBidSchema";
import { RubiconBidSchema } from "./RubiconBidSchema";
import { SharethroughBidSchema } from "./SharethroughBidSchema";
import { SmartAdServerBidSchema } from "./SmartAdServerBidSchema";
import { SovrnBidSchema } from "./SovrnBidSchema";
import { TheTraderDeskBidSchema } from "./TheTraderDeskBidSchema";
import { TripleliftBidSchema } from "./TripleliftBidSchema";

export const AllBidderSchemas = [
  AdagioBidSchema,
  AdaptMXSchema,
  AppnexusBidSchema,
  CriteoBidSchema,
  GumgumBidSchema,
  IxBidSchema,
  KargoBidSchema,
  MedianetBidSchema,
  OneAccordBidSchema,
  PubmaticBidSchema,
  RubiconBidSchema,
  SharethroughBidSchema,
  SmartAdServerBidSchema,
  SovrnBidSchema,
  TheTraderDeskBidSchema,
  TripleliftBidSchema,
];
